import { useEffect, useState } from "react";
import axios from "axios";

const useSeo = () => {
  const [seo, setSeo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/seo`);

        if (res.data.success) {
          setSeo(res.data.data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSeo();
  }, []);

  return { seo, loading };
};

export default useSeo;
